import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-elo-group',
  templateUrl: './modal-elo-group.component.html',
  styleUrls: ['./modal-elo-group.component.scss'],
})
export class ModalEloGroupComponent implements OnInit {
  @Output() onCloseAceleraMais: EventEmitter<boolean> = new EventEmitter();
  public showCloseButton = false;

  constructor(private bsModalRef: BsModalRef) {}

  // tslint:disable
  ngOnInit(): void {
    setTimeout(() => {
      this.showCloseButton = true;
    }, 3000);
  }
  // tslint:enable

  onClickClose() {
    this.bsModalRef.hide();
    this.onCloseAceleraMais.next(true);
  }

  redirectUser() {
    window.open('https://pt.surveymonkey.com/r/MFT7JJY', '_blank', 'noopener');
    this.onClickClose();
  }
}
